import qs from "qs";

export const urlForPin = (pin) => {
  const url = window.location.href.replace(/#\/.*$/, "");
  const urlWithPin = `${url}#/?${qs.stringify({ pin })}`;
  return { url, urlWithPin };
};
